import { cn } from '@/lib/utils';

/**
 * One labelled row: a fixed label column on the left, controls on the right.
 *
 * The fixed column is the point. Every row in the editor shares it, so the
 * controls line up down the page and the labels read as a column of prose —
 * "Calls / Continue / Then" — instead of each row finding its own alignment.
 *
 * This replaced inline controls embedded in a sentence. The sentence stated the
 * relationship well and looked like a ransom note: inputs are 36px tall and
 * text is 20px, so nothing shared a baseline, and any control that wrapped
 * broke the line in half.
 */
export function Field({
  label,
  htmlFor,
  hint,
  className,
  children,
}: {
  label: string;
  /** Points the label at its control, when there is a single obvious one. */
  htmlFor?: string;
  hint?: string;
  className?: string;
  children: React.ReactNode;
}): React.ReactElement {
  const Tag = htmlFor ? 'label' : 'div';
  return (
    <div className={cn('grid grid-cols-[10rem_1fr] items-start gap-x-4 py-2', className)}>
      <Tag {...(htmlFor ? { htmlFor } : {})} className="pt-2 text-sm text-muted-foreground">
        {label}
      </Tag>
      <div className="min-w-0">
        <div className="flex min-h-9 flex-wrap items-center gap-2">{children}</div>
        {hint && <p className="mt-1 text-xs text-muted-foreground">{hint}</p>}
      </div>
    </div>
  );
}
